const menuStatistics = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -5)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 6)">
          <path d="M0.375,11.625 L17.625,11.625"/>
          <polyline points="3.375 11.625 3.375 7.875 1.125 7.875 1.125 11.625"/>
          <polyline points="7.875 11.625 7.875 4.125 5.625 4.125 5.625 11.625"/>
          <polyline points="12.375 11.625 12.375 5.625 10.125 5.625 10.125 11.625"/>
          <polyline points="16.875 11.625 16.875 .375 14.625 .375 14.625 11.625"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>
`;

export default menuStatistics;
